// src/client/pages/order-success.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCart } from '../../core/context/CartContext';
import { useAuthClient } from '../../core/hooks/useAuthClient';
import api from '../../core/api';

const OrderSuccess = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { cartItems, clearCart } = useCart(); // ⬅️ on retire getTotalPrice
  const { getToken, getUser } = useAuthClient();

  useEffect(() => {
    const saveOrder = async () => {
      const token = getToken();
      const user = getUser();
      const clientKey = localStorage.getItem('selectedClient') || 'le_resto_local';

      if (!token || !user || !cartItems || Object.keys(cartItems).length === 0) {
        console.warn('⚠️ Impossible de sauvegarder la commande : données manquantes.');
        return;
      }

      const orderInfo = location.state?.orderInfo || {}; // données du formulaire
      const items = Object.values(cartItems).map(({ item, quantity }) => ({
        name: item.name,
        price: item.price,
        quantity,
      }));

      // ⛔️ On ne calcule plus le total côté front
      const pointsUsed = parseInt(orderInfo.pointsToUse || 0, 10);

      try {
        await api.post(
          `/api/orders`,
          {
            name: orderInfo.name,
            phone: orderInfo.phone,
            email: orderInfo.email,
            address: orderInfo.address,
            notes: orderInfo.comments || '',
            orderType: orderInfo.orderType || 'livraison',
            items,
            // ❌ total supprimé
            pointsUsed,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'x-client-key': clientKey,
            },
          }
        );
        console.log('✅ Commande sauvegardée avec succès.');
      } catch (err) {
        console.error('❌ Erreur sauvegarde commande :', err.response?.data || err.message);
      }
    };

    setShowModal(true);
    saveOrder();

    const timer = setTimeout(() => {
      clearCart();
      setShowModal(false);
      navigate('/');
    }, 3000);

    return () => clearCart(); // on vide bien si l’utilisateur quitte avant la redirection
  }, [navigate, clearCart, location, getToken, getUser, cartItems]);

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f7f7f7' }}>
      {showModal && (
        <div
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: '#fff',
            borderRadius: '12px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
            padding: '3rem',
            textAlign: 'center',
            zIndex: 9999,
          }}
        >
          <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>🎉 Merci pour votre commande !</h1>
          <p style={{ fontSize: '1.2rem', color: '#555' }}>Redirection vers l'accueil...</p>
        </div>
      )}
    </div>
  );
};

export default OrderSuccess;
